import { render } from "./BelgiumPage.vue?vue&type=template&id=54bc368c&scoped=true"
import script from "./BelgiumPage.vue?vue&type=script&lang=js"
export * from "./BelgiumPage.vue?vue&type=script&lang=js"

import "./BelgiumPage.vue?vue&type=style&index=0&id=54bc368c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bc368c"]])

export default __exports__